<template>
  <div
    class="rounded-md p-1 text-center text-xs select-none"
    :style="{
      backgroundColor: course.backgroundColor,
      color: course.foregroundColor,
    }"
  >
    {{ displayName }}
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { Course } from './course';

const props = defineProps<{
  course: Course;
}>();
const generateShortNameForCourse = (name: string): string => {
  const MAX_SHORTNAME_LENGTH = 5;
  return name
    .split(' ')
    .join('')
    .substring(0, MAX_SHORTNAME_LENGTH)
    .toUpperCase();
};
const displayName = computed(
  () => props.course.shortName ?? generateShortNameForCourse(props.course.name),
);
</script>
